<template>
  <v-app-bar
    :color="background"
    height="auto"
    class="mt-5 px-0 mx-6 border-radius-xl toolbar-content-padding-y-none"
    :class="
      navbarFixed
        ? 'position-sticky blur shadow-blur top-1 z-index-sticky py-2'
        : ''
    "
    flat
  >
    <v-row class="py-1">
      <v-col cols="12" sm="6" class="d-flex">
        <div>
          <v-breadcrumbs class="pb-0 pt-1 px-0">
            <v-breadcrumbs-item
              to="/dashboard"
              active-class="active-breadcrumb"
              class="opacity-5 text-dark"
            >
              <svg
                width="12px"
                height="12px"
                class="mb-1"
                viewBox="0 0 45 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>shop</title>
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    transform="translate(-1716.000000, -439.000000)"
                    fill="#252f40"
                    fill-rule="nonzero"
                  >
                    <g transform="translate(1716.000000, 291.000000)">
                      <g transform="translate(0.000000, 148.000000)">
                        <path
                          d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z"
                        ></path>
                        <path
                          d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </v-breadcrumbs-item>
            <li class="v-breadcrumbs__divider opacity-5 px-2 text-muted">/</li>
            <v-breadcrumbs-item class="opacity-5 text-dark">
              {{ $route.meta.groupName }}
            </v-breadcrumbs-item>
            <li class="v-breadcrumbs__divider opacity-5 px-2 text-muted">/</li>
            <v-breadcrumbs-item
              active-class="active-breadcrumb"
              class="no-default-hover text-dark"
            >
              <template v-if="$route.name === 'Dashboard'">Default</template>
              <template v-else>{{ $route.name }}</template>
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <h6 class="text-h6 font-weight-bolder text-typo mb-0">
            <!-- {{ $route.name }} -->
          </h6>
        </div>
        <div
          class="drawer-toggler pa-5 ms-6 cursor-pointer"
          :class="{ active: togglerActive }"
          @click="minifyDrawer"
          v-if="!$vuetify.breakpoint.mobile"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
            <i class="drawer-toggler-line bg-body"></i>
          </div>
        </div>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        class="d-flex align-center flex-wrap justify-end"
        :class="$vuetify.rtl ? 'text-sm-left' : 'text-sm-right'"
      >
        <v-spacer></v-spacer>
        <v-btn small @click="refreshPage" class="red--text mr-2" text outlined>
          <v-icon :class="$vuetify.breakpoint.lgAndUp ? 'mr-1' : ''">
            mdi-reload
          </v-icon>
          <span v-if="$vuetify.breakpoint.lgAndUp">Хуудас шинэчлэх</span>
        </v-btn>
        <!-- <v-form
          v-if="hasBg"
          @submit.prevent="submit"
          class="navbar-search navbar-search-light d-inline-block ms-auto"
          id="navbar-search-main"
        >
          <v-text-field
            rounded-sm
            hide-details
            outlined
            background-color="rgba(255,255,255,.9)"
            color="rgba(0,0,0,.6)"
            light
            placeholder="Xайx..."
            class="input-style font-size-input placeholder-lighter input-alternative input-icon border"
          >
            <template slot="prepend-inner">
              <v-icon color="rgba(0,0,0,.6)" size=".875rem"
                >fas fa-search</v-icon
              >
            </template>
          </v-text-field>
        </v-form> -->
        <v-btn
          v-if="userData != null"
          icon
          :ripple="false"
          class="ms-1 bg-gradient-info"
          title="Утсандаа QR-аар нэвтрэх"
          @click="qrLoginOpen = true"
        >
         <v-icon  color="white">mdi-cellphone-link</v-icon>
        </v-btn>

        <qr-login-dialog v-model="qrLoginOpen" />

        <v-btn
          v-if="isSpecialist(userData) || isNationalAdmin(userData) || canUseChat(userData)"
          icon
          :ripple="false"
          class="ms-2 me-1 bg-gradient-warning"
    
          title="Чат"
          @click="
            isSpecialist(userData) || isNationalAdmin(userData)
              ? chatBus.$emit('toggle-city')
              : chatBus.$emit('toggle')
          "
        >
          <v-badge
            :value="chatUnread > 0"
            :content="chatUnread > 99 ? '99+' : chatUnread"
            color="#ef4444"
            overlap
            bordered
            offset-x="8"
            offset-y="8"
          >
            <v-icon size="32" color="white">mdi-chat-processing</v-icon>
          </v-badge>
        </v-btn>
        <v-btn
          v-if="userData != null"
          @click="_logout"
          depressed
          :ripple="false"
          class="font-weight-600 text-body ls-0 text-capitalize pe-0 me-2"
          color="transparent"
        >
          <v-icon size="18" class="d-sm-none">mdi-logout</v-icon>
          <span
            class="d-sm-inline font-weight-bold d-none"
            :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
            :style="!hasBg ? 'color: rgba(0,0,0, .6)' : ''"
            >Гараx</span
          >
        </v-btn>

        <!-- to="/pages/authentication/login" -->
        <!-- 25219 -->
        <v-btn
          v-else
          depressed
          :ripple="false"
          class="font-weight-600 text-body ls-0 text-capitalize pe-0 me-2"
          color="transparent"
          to="/pages/authentication/login"
        >
          <v-icon size="16">fa fa-user me-sm-2 text-sm</v-icon>
          <span
            class="d-sm-inline font-weight-bold d-none"
            :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
            :style="!hasBg ? 'color: rgba(0,0,0, .6)' : ''"
            >Sign In</span
          >
        </v-btn>
        <v-btn
          elevation="0"
          :ripple="false"
          height="43"
          class="font-weight-600 text-capitalize drawer-toggler py-3 px-0 rounded-sm"
          :class="{
            'btn-dark-toggler-hover': !hasBg,
            'btn-toggler-hover': hasBg,
            active: togglerActive,
          }"
          v-if="$vuetify.breakpoint.mobile"
          color="transparent"
          @click="drawerClose"
        >
          <div class="drawer-toggler-inner">
            <i class="drawer-toggler-line text-body"></i>
            <i class="drawer-toggler-line text-body"></i>
            <i class="drawer-toggler-line text-body"></i>
          </div>
        </v-btn>

        <!-- <v-btn
          icon
          :ripple="false"
          :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
          class="text-body"
          :color="linkColor"
          small
          @click="$emit('toggleSettingsDrawer', true)"
        >
          <v-icon size="16">fa fa-cog text-sm</v-icon>
        </v-btn> -->

        <v-menu
          v-if="!$vuetify.breakpoint.mobile"
          transition="slide-y-transition"
          offset-y
          offset-x
          min-width="300"
          max-width="300"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              :ripple="false"
              :class="{ 'btn-dark-hover': !hasBg, 'btn-hover': hasBg }"
              class="text-body"
              :color="linkColor"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon size="16">fa fa-bell text-sm</v-icon>
            </v-btn>
          </template>

          <v-list class="py-0">
            <v-list-item
              v-for="(item, i) in dropdown"
              :key="i"
              class="pa-4 list-item-hover-active"
            >
              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg"
                v-if="item.avatar"
              >
                <v-img
                  :alt="`${item.avatar} avatar`"
                  :src="item.avatar"
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg bg-gradient-default"
                v-if="item.image"
              >
                <v-img :alt="`${item.image} image`" :src="item.image"></v-img>
              </v-list-item-avatar>

              <v-list-item-avatar
                :size="36"
                class="my-0 me-4 border-radius-lg bg-gradient-secondary"
                v-if="item.icon"
              >
                <v-img
                  :alt="`${item.icon} icon`"
                  :src="item.icon"
                  class="pa-2"
                  width="10"
                  height="10"
                  contain
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  <v-row>
                    <v-col>
                      <h6
                        class="text-sm font-weight-normal mb-1 text-typo"
                        v-html="item.title"
                      >
                        {{ item.title }}
                      </h6>
                    </v-col>
                  </v-row>
                </v-list-item-title>

                <p class="text-xs text-secondary mb-0">
                  <v-icon size="12" class="text-secondary"
                    >fa fa-clock me-1</v-icon
                  >
                  {{ item.time }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-app-bar>
</template>
<script>
const fb = require("../firebaseConfig.js");
import { store } from "@/store.js";
import { sync, call } from "vuex-pathify";
import { chatBus, canUseChat } from "@/chat/chat.js";
import { isSpecialist, isNationalAdmin } from "@/citymanager/city_chat.js";
import QrLoginDialog from "@/qrlogin/QrLoginDialog.vue";

export default {
  name: "app-bar",
  components: { QrLoginDialog },
  props: {
    background: String,
    hasBg: Boolean,
    linkColor: String,
    toggleActive: Boolean,
    navbarFixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...sync("*"),
    /** Green normally, blue while something is waiting. */
    chatButtonStyle() {
      const color = this.chatUnread
        ? "linear-gradient(135deg, #3b82f6, #2563eb)"
        : "linear-gradient(135deg, #22c55e, #16a34a)";
      return {
        background: color,
        borderRadius: "50%",
        height: "40px",
        width: "40px",
        // The soft ring is always there; it just changes colour when
        // something is waiting.
        boxShadow: this.chatUnread
          ? "0 0 0 5px rgba(37,99,235,.20)"
          : "0 0 0 5px rgba(34,197,94,.18)",
      };
    },
        
  },
  created() {
    chatBus.$on("unread", this.setChatUnread);
  },
  beforeDestroy() {
    chatBus.$off("unread", this.setChatUnread);
  },
  data() {
    return {
      chatBus: chatBus,
      canUseChat: canUseChat,
      isSpecialist: isSpecialist,
      isNationalAdmin: isNationalAdmin,
      qrLoginOpen: false,
      chatUnread: 0,
      drawer: false,
      togglerActive: false,
      dropdown: [
        // {
        //   avatar: require("@/assets/img/team-2.jpg"),
        //   title:
        //     '<span class="font-weight-bold">New message</span> from Laur</h6>',
        //   time: "13 minutes ago",
        // },
        // {
        //   image: require("@/assets/img/small-logos/logo-spotify.svg"),
        //   title:
        //     '<span class="font-weight-bold">New album</span> by Travis Scott',
        //   time: "1 day",
        // },
        // {
        //   icon: require("@/assets/img/icons/card.svg"),
        //   title: "Payment successfully completed",
        //   time: "2 days",
        // },
      ],
    };
  },

  methods: {
    setChatUnread(count) {
      this.chatUnread = count;
    },
    refreshPage() {
      window.location.reload();
    },
    ...call(["logout"]),
    _logout() {
      if (store.state.userData) {
        fb.auth
          .signOut()
          .then(() => {
            console.log(store.state, "YYYs");
            store.state.userData.ref
              .set({ lastLoggedOutAt: new Date() }, { merge: true })
              .then(() => {
                fb.db
                  .collection("logs")
                  .doc(store.state.userData.id)
                  .set(
                    { loggedOutAt: new Date(), logged: false },
                    { merge: true },
                  );
              })
              .then(() => {
                store.set("userData", null);
                store.set("mendleUserRef", null);
                store.set("selectedSchoolRef", null);
                store.set("logged", null);
                store.set("loggedEmail", null);

                this.$router.push({ name: "Login" });
                // this.$router.push({ name: "LoginTeacher" }); //25219
              });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    drawerClose() {
      this.togglerActive = !this.togglerActive;
      this.$emit("drawer-toggle", true);
    },
    minifyDrawer() {
      this.togglerActive = !this.togglerActive;
      this.mini = !this.mini;
      const body = document.getElementsByTagName("body")[0];

      if (body.classList.contains("drawer-mini")) {
        body.classList.remove("drawer-mini");
      } else {
        body.classList.add("drawer-mini");
      }
    },
  },
  watch: {
    logged(logged) {
      if (!logged) this._logout();
    },
    $route() {
      this.togglerActive = false;
    },
    deep: true,
    toggleActive(val) {
      this.togglerActive = val;
    },
  },
};
</script>
